import React from "react"

const Banner = ({text}) => {
  return (
    <React.Fragment>
      <div style={{ width: '100%', textAlign: 'center', padding: 10, backgroundColor: 'orange' }}>
        <b>{text}</b>
      </div>
    </React.Fragment>
  )
}

export default Banner
